export const isGuestOnList = async (tourId, email) => {
  const apiUrl = `/api/tours/${tourId}/check_guest_list?email=${encodeURIComponent(
    email
  )}`;

  try {
    const response = await fetch(apiUrl);

    if (response.status === 200) {
      return true;
    }

    if (response.status === 404) {
      return false;
    }

    throw new Error(`Unexpected response status: ${response.status}`);
  } catch (error) {
    console.error('Fetch error:', error);
    return 'Error checking guest list';
  }
};
